import Container from '@zenbusiness/zui/Container';
import { styled } from '@zenbusiness/zui/styles';

export const OptionButtonStyle = {
  borderRadius: 3,
  '&.MuiButton-sizeSmall': {
    padding: '10px'
  }
};

export const PaymentContainerStyled = styled(Container)(() => ({
  // Override the root style
  padding: '0 !important'
}));
